// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"179":"rule","826":"index","914":"records"}[chunkId] || chunkId) + "." + {"179":"5e62f7ee","480":"fd2d2613","826":"8e6dc8ee","914":"960b7eb7"}[chunkId] + ".css";
};